export default "{\n    \"poweredByResq\": \"Powered by ResQ\"\n}\n"